// extracted by mini-css-extract-plugin
export default {"selectSystem":"style--selectSystem--632c49","selectRow":"style--selectRow--6eaa68","label":"style--label--3e0c13","select":"style--select--30a20b"};